module.exports = __webpack_public_path__ + "fonts/Rubik-VariableFont_wght.d3c0428.ttf";